'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '1.8.16';


//////////////////
// WEBPACK FOOTER
// ./~/instantsearch.js/dist-es5-module/src/lib/version.js
// module id = 493
// module chunks = 0